import { Col, Row } from 'antd';
import { Button } from 'modules/common/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type PropsType = {
  onSave: () => void;
  onCancel: () => void;
  canSave: boolean;
  canCancel: boolean;
};

const ControlButtons: FC<PropsType> = ({
  onCancel,
  onSave,
  canCancel,
  canSave,
}) => {
  const { t } = useTranslation('settings.DonorSettings');
  return (
    <Row gutter={[10, 10]} justify="end">
      <Col>
        <Button onClick={onCancel} disabled={!canCancel} type="default">
          {t('cancel')}
        </Button>
      </Col>
      <Col>
        <Button onClick={onSave} disabled={!canSave} type="primary">
          {t('save')}
        </Button>
      </Col>
    </Row>
  );
};

export default ControlButtons;
